<div *ngIf="showChatPane && selectedChat" class="chat-window-wrapper">
  <chat-widget [searchQuery]="searchQuery" (closed)="closeChat()"></chat-widget>
</div>
<div class="messaging-widget" [class.open]="isOpen" [class.no-transition]="skipOpenAnimation">
  <div class="launcher-wrapper">
    <button class="messaging-widget-launcher" (click)="toggleWidget()">
      Messages
      <span class="arrow" [class.open]="isOpen"></span>
    </button>
    <div class="launcher-actions">
      <button mat-icon-button matTooltip="New message" (click)="openNewConversationDialog()">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="sidebarMenu" matTooltip="More Options">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #sidebarMenu="matMenu">
        <button mat-menu-item>
          <mat-icon>group_add</mat-icon>
          <span>New Group</span>
        </button>
        <button mat-menu-item>
          <mat-icon>archive</mat-icon>
          <span>Archived</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="widget-panel">
    <div class="search-wrapper">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Search chats..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchInput($event)"
        />
        @if (searchQuery) {
          <button mat-icon-button matSuffix (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
    @if (searchQuery.trim() && visibleChats.length === 0 && !isSearching) {
      <div class="no-results">
        <mat-icon>search_off</mat-icon>
        <span>No conversations found</span>
      </div>
    }
    <div class="chat-list">
      @for (chat of visibleChats; track chat.id) {
        <div class="chat-item" (click)="selectChat(chat)">
          <div class="avatar-wrapper">
            <div class="avatar-circle">
              <app-user-avatar [imageUrl]="chat.imageUrl" [name]="chat.name" />
            </div>
            @if (chat.unread) {
              <span
                class="avatar-unread-dot"
                aria-hidden="true"
                [attr.data-testid]="'avatar-unread-dot-' + chat.id"
              ></span>
            }
          </div>
          <div class="chat-info">
            <div class="chat-name-row">
              <span class="chat-name" [class.unread]="chat.unread">{{ chat.name }}</span>
              <span class="chat-time">{{ formatTime(chat.time) }}</span>
            </div>
            <div class="chat-preview-row">
              @if (chat.matchSnippet) {
                <span
                  class="chat-preview match-snippet"
                  [innerHTML]="chat.matchSnippet | highlight: searchQuery"
                ></span>
              } @else {
                <span class="chat-preview" [class.unread]="chat.unread">
                  {{ chat.lastMessage || 'No messages yet' }}
                </span>
              }
              @if (chat.matchCount && chat.matchCount > 1) {
                <span
                  class="match-count-badge"
                  aria-label="{{ chat.matchCount }} matching messages"
                >
                  {{ chat.matchCount }}
                </span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
